import { NOTIFICATION_TYPE_LIST } from '../../variables/notificationTypes';

// Shared 3-way segmented control - used by both the create modal (title+type
// only) and the Builder page (type can still be changed after creation).
export default function CommunicationTypePicker({ value, onChange, showHint }) {
   const current = NOTIFICATION_TYPE_LIST.find((t) => t.code === value);
   return (
      <div className='communication-type-picker'>
         {NOTIFICATION_TYPE_LIST.map((t) => (
            <label key={t.code} className={'communication-type-option' + (value === t.code ? ' active' : '')}
               style={{ '--type-accent': t.accent }}>
               <input type='radio' name='communication-type' value={t.code}
                  checked={value === t.code} onChange={() => onChange(t.code)} />
               {t.label}
            </label>
         ))}
         {showHint && current ? <p className='communication-type-hint'>{current.hint}</p> : ''}
      </div>
   );
}
